  import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';
import { ContactService } from '../contact.service';
import { PositionService } from '../../positions/position.service';
import { ContractorService } from '../../contractors/contractor.service';
import { Contact } from '../contact';
import { Router } from '@angular/router';
 
@Component({
  selector: 'app-contact-crud',
  templateUrl: './contact-crud.component.html',
  styleUrls: ['./contact-crud.component.css'],
  providers: [ContactService,PositionService,ContractorService],
  encapsulation: ViewEncapsulation.None
})
export class ContactCrudComponent implements OnInit {

	msgs: Message[] = [];
	button_caption: string = 'Сохранить';
  button_icon: string = "fa fa-save";
  contacts: Contact;
  genders: {}[] = [];
  id: string = null;
  loading: boolean = false;
  selectedGender: string;
  selectedPosition: string;
  selectedContractor: string;


  constructor(
              private location: Location,
              private router: Router,
              private contactService: ContactService,
              private positionService: PositionService,
              private contractorService: ContractorService,
              private activatedRoute: ActivatedRoute
              ) { 

          this.genders.push({label: "Мужской", value: "0"});
          this.genders.push({label: "Женский", value: "1"});

        
         
          activatedRoute.params.subscribe(params=>{this.id=params['id']});
          if(this.id){
            this.loading=true;	 
               this.contactService.getContactById(this.id).subscribe(response=>{

                    this.positionService.getPosition(1).subscribe(response=>{this.contacts.positions=response['data'].map(function(value: any){
                                  return {label:value.name, value: value.id};
                          });})
                    this.contractorService.getContractorList().subscribe(response=>{this.contacts.contractors=response['data'].map(function(value: any){
                                  return {label:value.name, value: value.id};
                    });
                  	this.loading=false;	 
                    })

                   this.selectedContractor = response['data'].contractor.id;
                   this.selectedPosition = response['data'].position.id;
                   this.selectedGender = response['data'].gender;
                   this.contacts = response['data'];
               });

              this.button_caption="Редактировать";
              this.button_icon="fa fa-edit";

          } else{
                this.positionService.getPosition(1).subscribe(response=>{this.contacts.positions=response['data'].map(function(value: any){
                                  return {label:value.name, value: value.id};
                          });})

                this.contractorService.getContractorList().subscribe(response=>{this.contacts.contractors=response['data'].map(function(value: any){
                                  return {label:value.name, value: value.id};
                  });
                })
          } 
    }

  ngOnInit() {
      this.contacts = {
        id: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        icon: "",
        date_birthday: "",
        genders: [],
        phone: "",
        email: "",
        address: "",
        contractors: [],
        positions: [],
        description: "",
        available: true
      }

  }
  
  backClicked() {
        this.location.back();
  }

  crud(form: NgForm){
    this.loading=true;	
   
       if(!this.id){
             this.contactService.createContact(form.value)
             .subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/contact']);}
                  , (error)=>{this.loading=false;});

         }else{
           this.contactService.updateContact(form.value,this.id)
             .subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/contact']);}
                  , (error)=>{this.loading=false;});
         }
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contacts/contact-crud/contact-crud.component.ts